import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  HiHome,
  HiAcademicCap,
  HiHeart,
  HiCog6Tooth,
  HiChevronDoubleLeft,
  HiChevronDoubleRight,
  HiUserCircle,
  HiInbox,
  HiCurrencyDollar,
  HiChatBubbleLeftRight,
  HiDocumentChartBar,
  HiChevronDown,
  HiUserGroup,
  HiChartBar,
  HiClipboardDocumentList,
  HiBookOpen,
  HiCog,
  HiBell,
  HiShieldCheck,
  HiBriefcase,
  HiSparkles,
  HiCalendar,
  HiClock,
  HiDocumentText,
  HiCheckCircle,
  HiScale,
  HiRocketLaunch,
  HiTrash,
  HiUserPlus,
} from 'react-icons/hi2';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, firestore } from '../../../database/firebase';
import { doc, getDoc } from 'firebase/firestore';

const navLinks = [
  { label: 'Dashboard', icon: HiHome, key: 'dashboard', color: 'from-blue-500 to-blue-600' },
  { label: 'CRM', icon: HiUserGroup, key: 'crm', color: 'from-blue-500 to-blue-600' },
  {
    label: 'Document Bank',
    icon: HiDocumentText,
    key: 'document-bank',
    color: 'from-blue-500 to-blue-600',
  },

  {
    label: 'Programs',
    icon: HiAcademicCap,
    key: 'programs',
    color: 'from-blue-500 to-blue-600',
    submenu: [
      { label: 'Training', key: 'training', icon: HiAcademicCap },
      { label: 'Product Development', key: 'product-development', icon: HiRocketLaunch },
      {
        label: 'Commercialisation',
        key: 'commercialisation',
        icon: HiBriefcase,
        submenu: [
          {
            label: 'Commercialisation Readiness Checklist',
            key: 'commercialisation-readiness-checklist',
            icon: HiCheckCircle,
          },
          {
            label: 'Go to Market Strategy and Commercialisation Plan',
            key: 'go-to-market-strategy',
            icon: HiChartBar,
          },
          {
            label: 'Start-Up Launch Checklist',
            key: 'startup-launch-checklist',
            icon: HiCheckCircle,
          },
          {
            label: 'Admin Panel',
            key: 'commercialisation-admin-panel',
            icon: HiUserGroup,
          },
        ],
      },
      { label: 'Scaling', key: 'scalingmodules', icon: HiScale },
      { label: 'Program Health Check', key: 'program-health-check', icon: HiHeart },
      { label: 'Funding', key: 'funding', icon: HiCurrencyDollar },
    ],
  },

  {
    label: 'Analytics',
    icon: HiChartBar,
    key: 'analytics',
    color: 'from-green-500 to-green-600',
    submenu: [
      {
        label: 'Profiling Analytics',
        key: 'profiling-analytics',
        icon: HiClipboardDocumentList,
      },
      {
        label: 'Commercialisation Analytics',
        key: 'commercialisation-analytics',
        icon: HiBriefcase,
      },
    ],
  },

  {
    label: 'Profiling',
    icon: HiClipboardDocumentList,
    key: 'profiling',
    color: 'from-green-500 to-green-600',
    submenu: [{ label: 'Business Health Check', key: 'business-health-check', icon: HiHeart }],
  },
  {
    label: 'Communication',
    icon: HiChatBubbleLeftRight,
    key: 'communication',
    color: 'from-blue-500 to-blue-600',
    submenu: [
      { label: 'Reports', key: 'reports', icon: HiDocumentChartBar },
      {
        label: 'Monthly Coaching Reports',
        key: 'monthly-coaching-reports',
        icon: HiDocumentChartBar,
      },
    ],
  },

  {
    label: 'Inbox',
    key: 'inbox',
    icon: HiInbox,
    submenu: [
      { label: 'Public Chat', key: 'public', icon: HiChatBubbleLeftRight },
      { label: 'Private Inbox', key: 'private', icon: HiInbox },
    ],
  },
  {
    label: 'Sessions',
    icon: HiCalendar,
    key: 'sessions',
    color: 'from-blue-500 to-blue-600',
    submenu: [
      { label: 'Session Calendar', key: 'session-calendar', icon: HiCalendar },
      { label: 'Session History', key: 'session-history', icon: HiClock },
      { label: 'Session Notes', key: 'session-notes', icon: HiDocumentText },
      { label: 'Follow-up Tasks', key: 'follow-up-tasks', icon: HiCheckCircle },
    ],
  },
  {
    label: 'Resources',
    icon: HiBriefcase,
    key: 'resources',
    color: 'from-blue-500 to-blue-600',
    submenu: [
      { label: 'Coaching Tools', key: 'coaching-tools', icon: HiSparkles },
      { label: 'Best Practices', key: 'best-practices', icon: HiShieldCheck },
      { label: 'Knowledge Base', key: 'knowledge-base', icon: HiBookOpen },
      { label: 'Templates', key: 'templates', icon: HiDocumentText },
      { label: 'Team Management', key: 'team-management', icon: HiUserGroup },
    ],
  },
  {
    label: 'User Management',
    icon: HiUserGroup,
    key: 'user-management',
    color: 'from-blue-500 to-blue-600',
    submenu: [
      { label: 'Business Advisors', key: 'moderators', icon: HiUserGroup },
      { label: 'Clients', key: 'clients', icon: HiUserPlus },
      { label: 'Alumni', key: 'alumni', icon: HiUserGroup },
      { label: 'Archives', key: 'junk-management', icon: HiTrash },
    ],
  },
  {
    label: 'Settings',
    icon: HiCog6Tooth,
    key: 'settings',
    color: 'from-blue-500 to-blue-600',
    submenu: [
      { label: 'Profile Settings', key: 'profile-settings', icon: HiUserCircle },
      { label: 'Account Security', key: 'account-security', icon: HiShieldCheck },
      { label: 'Notification Preferences', key: 'notification-preferences', icon: HiBell },
      { label: 'System Preferences', key: 'system-preferences', icon: HiCog },
    ],
  },
];

const CoachesSidebar = ({
  collapsed,
  setCollapsed,
  selected,
  setSelected,
  inboxSubsection,
  onInboxSubsectionChange,
}) => {
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [expandedMenus, setExpandedMenus] = useState({});

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async currentUser => {
      setLoading(true);
      if (currentUser) {
        setUser(currentUser);
        try {
          const userDocRef = doc(firestore, 'coaches', currentUser.uid);
          const userDocSnap = await getDoc(userDocRef);
          if (userDocSnap.exists()) {
            setUserProfile(userDocSnap.data());
          } else {
            setUserProfile(null);
          }
        } catch (error) {
          setUserProfile(null);
        }
      } else {
        setUser(null);
        setUserProfile(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // Auto-expand parent menus when nested items are selected
  useEffect(() => {
    navLinks.forEach(link => {
      if (link.submenu) {
        const hasSelectedSubmenu = link.submenu.some(subItem => {
          if (subItem.submenu) {
            return subItem.submenu.some(nestedItem => selected === nestedItem.key);
          }
          return selected === subItem.key;
        });
        if (hasSelectedSubmenu) {
          setExpandedMenus(prev => ({ ...prev, [link.key]: true }));
          // Also expand the parent submenu if a nested item is selected
          link.submenu.forEach(subItem => {
            if (
              subItem.submenu &&
              subItem.submenu.some(nestedItem => selected === nestedItem.key)
            ) {
              setExpandedMenus(prev => ({ ...prev, [subItem.key]: true }));
            }
          });
        }
      }
    });
  }, [selected]);

  const displayData = {
    firstName: userProfile?.firstname || user?.displayName?.split(' ')[0] || 'Coach',
    lastName: userProfile?.lastname || user?.displayName?.split(' ')[1] || '',
    email: user?.email || '',
  };

  const initials =
    `${displayData.firstName.charAt(0)}${displayData.lastName.charAt(0)}`.toUpperCase();

  const sidebarVariants = {
    expanded: { width: 280, x: 0 },
    collapsed: { width: 80, x: 0 },
  };

  const contentVariants = {
    expanded: { opacity: 1, x: 0 },
    collapsed: { opacity: 0, x: -20 },
  };

  const toggleSubmenu = key => {
    setExpandedMenus(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleMenuClick = link => {
    if (link.submenu) {
      toggleSubmenu(link.key);
    } else if (link.key === 'inbox') {
      setSelected('inbox');
    } else {
      setSelected(link.key);
    }
    if (window.innerWidth < 1024) {
      setCollapsed(true);
    }
  };

  const handleSubmenuClick = (subItem, parentKey) => {
    // If subItem has its own submenu, toggle it instead of selecting
    if (subItem.submenu && subItem.submenu.length > 0) {
      toggleSubmenu(subItem.key);
      return;
    }

    if (parentKey === 'inbox') {
      onInboxSubsectionChange(subItem.key);
      setSelected('inbox');
    } else {
      setSelected(subItem.key);
    }
    if (window.innerWidth < 1024) {
      setCollapsed(true);
    }
  };

  return (
    <motion.aside
      variants={sidebarVariants}
      animate={collapsed ? 'collapsed' : 'expanded'}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
      className="fixed z-50 flex h-full flex-col border-r border-gray-200 bg-white shadow-lg lg:relative"
    >
      <div className="flex items-center justify-between border-b border-gray-200 px-3 py-3 md:px-4 md:py-4">
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setCollapsed(!collapsed)}
          className="rounded-xl p-1.5 transition-colors hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500/20 md:p-2"
        >
          <motion.div animate={{ rotate: collapsed ? 0 : 180 }} transition={{ duration: 0.3 }}>
            {collapsed ? (
              <HiChevronDoubleRight className="h-4 w-4 text-gray-600 md:h-5 md:w-5" />
            ) : (
              <HiChevronDoubleLeft className="h-4 w-4 text-gray-600 md:h-5 md:w-5" />
            )}
          </motion.div>
        </motion.button>
        {collapsed && !loading && user && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-100 text-xs font-semibold text-blue-700 shadow-sm"
          >
            {initials}
          </motion.div>
        )}
      </div>

      <AnimatePresence>
        {!collapsed && (
          <motion.div
            variants={contentVariants}
            initial="collapsed"
            animate="expanded"
            exit="collapsed"
            transition={{ duration: 0.2, delay: 0.15 }}
            className="border-b border-gray-200 px-3 py-4 md:px-4 md:py-6"
          >
            {loading ? (
              <div className="flex flex-col items-center gap-3">
                <div className="h-10 w-10 animate-pulse rounded-full bg-gray-200 md:h-12 md:w-12"></div>
                <div className="space-y-2">
                  <div className="h-3 w-16 animate-pulse rounded bg-gray-200 md:h-4 md:w-20"></div>
                  <div className="h-2 w-20 animate-pulse rounded bg-gray-200 md:h-3 md:w-24"></div>
                </div>
              </div>
            ) : user ? (
              <div className="flex flex-col items-center gap-3">
                <div className="relative">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100 font-semibold text-blue-700 shadow-lg md:h-12 md:w-12">
                    {initials}
                  </div>
                  <div className="absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full border-2 border-white bg-green-500 md:h-4 md:w-4"></div>
                </div>
                <div className="text-center">
                  <div className="text-xs font-semibold text-black md:text-sm">
                    {displayData.firstName} {displayData.lastName}
                  </div>
                  <div className="max-w-full truncate text-[10px] text-gray-500 md:text-xs">
                    {displayData.email}
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-center gap-3">
                <HiUserCircle className="h-10 w-10 text-gray-300 md:h-12 md:w-12" />
                <span className="text-xs text-gray-400 md:text-sm">Not logged in</span>
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>

      <nav className="flex-1 overflow-y-auto px-2 py-3 md:px-3 md:py-4">
        <div className="space-y-2">
          {navLinks.map((link, index) => {
            const Icon = link.icon;
            const isSelected =
              selected === link.key ||
              (link.submenu &&
                link.submenu.some(subItem => {
                  if (subItem.submenu) {
                    return subItem.submenu.some(nestedItem => selected === nestedItem.key);
                  }
                  return selected === subItem.key;
                }));
            const isHovered = hoveredItem === link.key;
            const hasSubmenu = link.submenu && link.submenu.length > 0;
            const isExpanded = expandedMenus[link.key];

            return (
              <div key={link.key}>
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.05 }}
                >
                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => handleMenuClick(link)}
                    onHoverStart={() => setHoveredItem(link.key)}
                    onHoverEnd={() => setHoveredItem(null)}
                    className={[
                      'relative flex w-full items-center justify-between rounded-xl px-2 py-2.5 text-left transition-all duration-200 md:px-3 md:py-3',
                      isSelected
                        ? 'border-l-4 border-blue-500 bg-blue-50 text-blue-700 shadow-md'
                        : '',
                      isHovered
                        ? 'hover:bg-gray-50 hover:text-black'
                        : 'text-gray-600 hover:bg-gray-100 hover:text-black',
                    ]
                      .filter(Boolean)
                      .join(' ')}
                  >
                    <div className="flex items-center gap-4">
                      <div className="relative">
                        <Icon
                          className={`h-4 w-4 flex-shrink-0 transition-colors md:h-5 md:w-5 ${isSelected ? 'text-blue-500' : isHovered ? 'text-black' : 'text-gray-400'}`}
                        />
                        {collapsed && isHovered && (
                          <motion.div
                            initial={{ opacity: 0, x: 10 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 10 }}
                            className="absolute left-8 top-1/2 z-50 hidden -translate-y-1/2 rounded-lg bg-black px-2 py-1 text-xs text-white shadow-lg lg:block"
                          >
                            {link.label}
                            <div className="absolute left-0 top-1/2 -translate-x-1 -translate-y-1/2 border-4 border-transparent border-r-black"></div>
                          </motion.div>
                        )}
                      </div>
                      <AnimatePresence>
                        {!collapsed && (
                          <motion.span
                            variants={contentVariants}
                            initial="collapsed"
                            animate="expanded"
                            exit="collapsed"
                            transition={{ duration: 0.2 }}
                            className={`text-xs md:text-sm ${isSelected ? 'font-bold text-black' : 'font-medium'}`}
                          >
                            {link.label}
                          </motion.span>
                        )}
                      </AnimatePresence>
                    </div>
                    {hasSubmenu && !collapsed && (
                      <motion.div
                        animate={{ rotate: isExpanded ? 180 : 0 }}
                        transition={{ duration: 0.2 }}
                        className="flex-shrink-0"
                      >
                        <HiChevronDown
                          className={`h-3.5 w-3.5 md:h-4 md:w-4 ${isSelected ? 'text-blue-600' : 'text-gray-400'}`}
                        />
                      </motion.div>
                    )}
                  </motion.button>
                </motion.div>

                {hasSubmenu && isExpanded && !collapsed && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    exit={{ opacity: 0, height: 0 }}
                    className="ml-6 mt-1 space-y-0.5 border-l-2 border-gray-100 pl-2 md:pl-3"
                  >
                    {link.submenu.map(subItem => {
                      const SubIcon = subItem.icon;
                      const isSubSelected =
                        subItem.key === 'inbox'
                          ? selected === 'inbox' && inboxSubsection === subItem.key
                          : selected === subItem.key;
                      const hasNestedSubmenu = subItem.submenu && subItem.submenu.length > 0;

                      return (
                        <div key={subItem.key}>
                          <motion.button
                            whileHover={{ scale: 1.01 }}
                            whileTap={{ scale: 0.99 }}
                            onClick={() => handleSubmenuClick(subItem, link.key)}
                            className={[
                              'flex w-full items-center justify-between gap-2 rounded-lg border-l-2 px-2 py-1.5 text-xs transition-all duration-200 md:gap-3 md:px-3 md:py-2 md:text-sm',
                              isSubSelected
                                ? 'border-blue-500 bg-blue-50 font-medium text-blue-700'
                                : 'border-gray-200',
                              hasNestedSubmenu && subItem.key !== 'commercialisation'
                                ? 'font-medium'
                                : '',
                              isHovered
                                ? 'hover:border-gray-300 hover:bg-gray-50 hover:text-black'
                                : 'text-gray-600 hover:border-gray-300 hover:bg-gray-50 hover:text-black',
                            ]
                              .filter(Boolean)
                              .join(' ')}
                          >
                            <div className="flex items-center gap-2 md:gap-3">
                              <SubIcon
                                className={`h-3 w-3 flex-shrink-0 md:h-4 md:w-4 ${isSubSelected ? 'text-blue-600' : 'text-gray-500'}`}
                              />
                              <span className="truncate">{subItem.label}</span>
                            </div>
                            {hasNestedSubmenu && (
                              <motion.div
                                animate={{ rotate: expandedMenus[subItem.key] ? 180 : 0 }}
                                transition={{ duration: 0.2 }}
                                className="flex-shrink-0"
                              >
                                <HiChevronDown
                                  className={`h-3 w-3 md:h-3.5 md:w-3.5 ${isSubSelected ? 'text-blue-600' : 'text-gray-400'}`}
                                />
                              </motion.div>
                            )}
                          </motion.button>

                          {hasNestedSubmenu && expandedMenus[subItem.key] && (
                            <motion.div
                              initial={{ opacity: 0, height: 0 }}
                              animate={{ opacity: 1, height: 'auto' }}
                              exit={{ opacity: 0, height: 0 }}
                              className="ml-4 mt-1 space-y-0.5 border-l-2 border-gray-200 pl-3 md:pl-4"
                            >
                              {subItem.submenu.map((nestedItem, nestedIndex) => {
                                const NestedIcon = nestedItem.icon;
                                const isNestedSelected = selected === nestedItem.key;

                                return (
                                  <motion.button
                                    key={nestedItem.key}
                                    initial={{ opacity: 0, x: -10 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ delay: nestedIndex * 0.05 }}
                                    whileHover={{ scale: 1.01, x: 2 }}
                                    whileTap={{ scale: 0.99 }}
                                    onClick={() => handleSubmenuClick(nestedItem, subItem.key)}
                                    className={[
                                      'flex w-full items-center gap-2 rounded-md border-l-2 px-2 py-1.5 text-xs transition-all duration-200 md:gap-2.5 md:px-2.5',
                                      isNestedSelected
                                        ? 'border-blue-500 bg-blue-50 font-medium text-blue-700'
                                        : 'border-gray-200',
                                      isHovered
                                        ? 'hover:translate-x-1 hover:border-gray-300 hover:bg-gray-50 hover:text-black'
                                        : 'text-gray-600 hover:translate-x-1 hover:border-gray-300 hover:bg-gray-50 hover:text-black',
                                    ]
                                      .filter(Boolean)
                                      .join(' ')}
                                  >
                                    <NestedIcon
                                      className={`h-3.5 w-3.5 flex-shrink-0 md:h-4 md:w-4 ${isNestedSelected ? 'text-blue-600' : 'text-gray-400'}`}
                                    />
                                    <span className="truncate text-xs md:text-xs">
                                      {nestedItem.label}
                                    </span>
                                  </motion.button>
                                );
                              })}
                            </motion.div>
                          )}
                        </div>
                      );
                    })}
                  </motion.div>
                )}
              </div>
            );
          })}
        </div>
      </nav>

      <AnimatePresence>
        {!collapsed && (
          <motion.div
            variants={contentVariants}
            initial="collapsed"
            animate="expanded"
            exit="collapsed"
            transition={{ duration: 0.2 }}
            className="border-t border-gray-200 px-3 py-3 md:px-4 md:py-4"
          >
            <div className="text-center text-[10px] text-gray-400 md:text-xs">
              © 2025 411 • Group
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.aside>
  );
};

export default CoachesSidebar;
